var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-tag-group" },
    _vm._l(_vm.data, function (tag) {
      return _c(
        "yxt-tag",
        {
          key: tag.id,
          staticClass: "hand",
          attrs: { effect: _vm.getPlain(tag), type: _vm.getType(tag) },
          on: {
            click: function ($event) {
              return _vm.select(tag)
            },
          },
        },
        [
          _vm.multi
            ? _c(
                "span",
                { staticClass: "yxtbiz-tag-selected-icon" },
                [
                  _c("yxt-svg", {
                    staticClass: "color-primary-6 v-top",
                    attrs: {
                      width: "14px",
                      height: "14px",
                      "icon-class": "pick",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c("span", { staticClass: "color-gray-9" }, [
            _vm._v(_vm._s(tag.tagName)),
          ]),
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }